import hasRole from './hasRole'
import hasPermi from './hasPermi'

const install = function(Vue) {
  Vue.directive('has-role', hasRole)
  Vue.directive('has-permi', hasPermi)
}

export default install
